import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import storage from '../nativeStorage';

export default function SuperAdminDashboard() {
  const navigate = useNavigate();
  const token = storage.getItem("token");
  const [societies, setSocieties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [deleteModal, setDeleteModal] = useState(null);
  const [deleteBusy, setDeleteBusy] = useState(false);
  const [pendingClubs, setPendingClubs] = useState([]);
  const [clubBusyId, setClubBusyId] = useState(null);

  const loadPendingClubs = () => {
    axios.get("/api/auth/superadmin/pending-clubs", { headers: { Authorization: "Bearer " + token } })
      .then(res => setPendingClubs(res.data))
      .catch(() => {});
  };

  useEffect(() => {
    if (!token) { navigate("/superadmin"); return; }
    axios.get("/api/auth/superadmin/societies", { headers: { Authorization: "Bearer " + token } })
      .then(res => setSocieties(res.data))
      .catch(e => { if (e.response?.status === 403) navigate("/superadmin"); else setError(e.response?.data?.error || "Failed to load"); })
      .finally(() => setLoading(false));
    loadPendingClubs();
  }, []);

  const approveClub = async (id) => {
    setClubBusyId(id);
    try {
      await axios.post(`/api/auth/superadmin/club/${id}/approve`, {}, { headers: { Authorization: "Bearer " + token } });
      setPendingClubs(prev => prev.filter(c => c.id !== id));
    } catch (e) { alert("Failed to approve: " + (e.response?.data?.error || e.message)); }
    finally { setClubBusyId(null); }
  };

  const rejectClub = async (id) => {
    if (!window.confirm("Reject this club registration?")) return;
    setClubBusyId(id);
    try {
      await axios.post(`/api/auth/superadmin/club/${id}/reject`, {}, { headers: { Authorization: "Bearer " + token } });
      setPendingClubs(prev => prev.filter(c => c.id !== id));
    } catch (e) { alert("Failed to reject: " + (e.response?.data?.error || e.message)); }
    finally { setClubBusyId(null); }
  };

  const logout = () => {
    storage.removeItem("token");
    storage.removeItem("superadmin");
    navigate("/superadmin");
  };

  const loginAs = async (societyId) => {
    try {
      const res = await axios.post("/api/auth/superadmin/loginas", { society_id: societyId }, { headers: { Authorization: "Bearer " + token } });
      storage.setItem("token", res.data.token);
      storage.removeItem("superadmin");
      window.location.href = "/players";
    } catch(e) { setError("Failed to switch society"); }
  };

  const deleteSociety = async (society) => {
    setDeleteBusy(true);
    try {
      await axios.delete("/api/auth/superadmin/society/" + society.id, { headers: { Authorization: "Bearer " + token } });
      setSocieties(prev => prev.filter(s => s.id !== society.id));
      setDeleteModal(null);
    } catch(e) { alert("Failed to delete: " + (e.response?.data?.error || e.message)); }
    finally { setDeleteBusy(false); }
  };

  const filtered = societies.filter(s =>
    s.name.toLowerCase().includes(search.toLowerCase()) ||
    s.email.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ minHeight: "100vh", background: "#1e1b4b" }}>

      {deleteModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
          <div style={{ background: "#312e81", borderRadius: "12px", padding: "28px", maxWidth: "420px", width: "100%", boxShadow: "0 8px 32px rgba(0,0,0,0.5)" }}>
            <div style={{ fontSize: "18px", fontWeight: "800", color: "white", marginBottom: "12px" }}>⚠️ Delete Society</div>
            <div style={{ fontSize: "13px", color: "#c7d2fe", marginBottom: "8px" }}>You are about to permanently delete:</div>
            <div style={{ background: "#1e1b4b", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px" }}>
              <div style={{ color: "white", fontWeight: "700" }}>{deleteModal.name}</div>
              <div style={{ color: "#a5b4fc", fontSize: "12px", marginTop: "4px" }}>{deleteModal.email}</div>
              <div style={{ color: "#ef4444", fontSize: "12px", marginTop: "8px", fontWeight: "600" }}>
                This will permanently delete ALL players, events, scores and archives for this society. This cannot be undone.
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <button onClick={() => setDeleteModal(null)}
                style={{ background: "none", border: "1px solid #4f46e5", color: "#a5b4fc", borderRadius: "8px", padding: "8px 20px", fontSize: "13px", cursor: "pointer" }}>
                Cancel
              </button>
              <button onClick={() => deleteSociety(deleteModal)} disabled={deleteBusy}
                style={{ background: "#dc2626", color: "white", border: "none", borderRadius: "8px", padding: "8px 20px", fontSize: "13px", fontWeight: "700", cursor: "pointer", opacity: deleteBusy ? 0.7 : 1 }}>
                {deleteBusy ? "Deleting..." : "Delete Permanently"}
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={{ background: "#312e81", padding: "14px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span style={{ fontSize: "22px" }}>🔑</span>
          <div>
            <div style={{ color: "white", fontWeight: "800", fontSize: "15px" }}>System Administration</div>
            <div style={{ color: "#a5b4fc", fontSize: "11px" }}>Golf Society Manager — Triton42</div>
          </div>
        </div>
        <button onClick={() => window.location.href='/superadmin/licences'} style={{ background:'#4f46e5', color:'white', border:'none', borderRadius:'6px', padding:'6px 14px', fontSize:'12px', fontWeight:'700', cursor:'pointer', marginRight:'8px' }}>🔑 Licences</button>
        <button onClick={() => window.location.href='/superadmin/mailmerge'} style={{ background:'#4f46e5', color:'white', border:'none', borderRadius:'6px', padding:'6px 14px', fontSize:'12px', fontWeight:'700', cursor:'pointer', marginRight:'8px' }}>📧 Mail Merge</button>
        <button onClick={logout} style={{ background: "#dc2626", color: "white", border: "none", borderRadius: "6px", padding: "6px 14px", fontSize: "12px", fontWeight: "700", cursor: "pointer" }}>Logout</button>
      </div>

      <div style={{ padding: "24px", maxWidth: "900px", margin: "0 auto" }}>
        <div style={{ display: "flex", gap: "16px", marginBottom: "20px", flexWrap: "wrap" }}>
          <div style={{ background: "#312e81", borderRadius: "10px", padding: "16px 20px", flex: 1, minWidth: "140px" }}>
            <div style={{ color: "#a5b4fc", fontSize: "11px", fontWeight: "600", marginBottom: "4px" }}>TOTAL SOCIETIES</div>
            <div style={{ color: "white", fontSize: "28px", fontWeight: "800" }}>{filtered.length}</div>
          </div>
          <div style={{ background: "#312e81", borderRadius: "10px", padding: "16px 20px", flex: 1, minWidth: "140px" }}>
            <div style={{ color: "#a5b4fc", fontSize: "11px", fontWeight: "600", marginBottom: "4px" }}>TOTAL PLAYERS</div>
            <div style={{ color: "white", fontSize: "28px", fontWeight: "800" }}>{societies.reduce((a, s) => a + parseInt(s.players || 0), 0)}</div>
          </div>
          <div style={{ background: "#312e81", borderRadius: "10px", padding: "16px 20px", flex: 1, minWidth: "140px" }}>
            <div style={{ color: "#a5b4fc", fontSize: "11px", fontWeight: "600", marginBottom: "4px" }}>TOTAL EVENTS</div>
            <div style={{ color: "white", fontSize: "28px", fontWeight: "800" }}>{societies.reduce((a, s) => a + parseInt(s.events || 0), 0)}</div>
          </div>
        </div>

        {error && <div style={{ background: "#fef2f2", color: "#b91c1c", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "16px" }}>{error}</div>}

        {pendingClubs.length > 0 && (
          <div style={{ marginBottom: "24px" }}>
            <div style={{ color: "#fcd34d", fontWeight: "700", fontSize: "13px", marginBottom: "10px" }}>📍 CLUBS AWAITING APPROVAL ({pendingClubs.length})</div>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {pendingClubs.map(c => (
                <div key={c.id} style={{ background: "#451a03", border: "1px solid #92400e", borderRadius: "10px", padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", flexWrap: "wrap" }}>
                  <div>
                    <div style={{ color: "white", fontWeight: "700", fontSize: "14px" }}>{c.name}</div>
                    <div style={{ color: "#fcd34d", fontSize: "12px", marginTop: "2px" }}>{c.email}</div>
                    <div style={{ color: "#d6d3d1", fontSize: "11px", marginTop: "4px" }}>
                      {[c.address_line1, c.city, c.county, c.postcode, c.country].filter(Boolean).join(", ")}
                    </div>
                    <div style={{ color: "#a8a29e", fontSize: "11px", marginTop: "2px" }}>
                      Registered {new Date(c.created_at).toLocaleDateString('en-GB')}
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <button onClick={() => approveClub(c.id)} disabled={clubBusyId === c.id}
                      style={{ background: "#16a34a", color: "white", border: "none", borderRadius: "6px", padding: "8px 16px", fontSize: "12px", fontWeight: "700", cursor: "pointer", whiteSpace: "nowrap", opacity: clubBusyId === c.id ? 0.6 : 1 }}>
                      ✓ Approve
                    </button>
                    <button onClick={() => rejectClub(c.id)} disabled={clubBusyId === c.id}
                      style={{ background: "#dc2626", color: "white", border: "none", borderRadius: "6px", padding: "8px 16px", fontSize: "12px", fontWeight: "700", cursor: "pointer", whiteSpace: "nowrap", opacity: clubBusyId === c.id ? 0.6 : 1 }}>
                      ✕ Reject
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Search societies by name or email..."
          style={{ width: "100%", border: "1px solid #4f46e5", background: "#312e81", color: "white", borderRadius: "8px", padding: "10px 14px", fontSize: "14px", marginBottom: "16px", boxSizing: "border-box" }} />

        {loading ? (
          <div style={{ color: "#a5b4fc", textAlign: "center", padding: "40px" }}>Loading...</div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {filtered.map(s => (
              <div key={s.id} style={{ background: "#312e81", borderRadius: "10px", padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", flexWrap: "wrap" }}>
                <div>
                  <div style={{ color: "white", fontWeight: "700", fontSize: "14px" }}>{s.name}</div>
                  <div style={{ color: "#a5b4fc", fontSize: "12px", marginTop: "2px" }}>{s.email}</div>
                  <div style={{ color: "#6b7280", fontSize: "11px", marginTop: "4px" }}>
                    {s.players} players · {s.events} events · Registered {new Date(s.created_at).toLocaleDateString('en-GB')}
                  </div>
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                  <button onClick={() => loginAs(s.id)}
                    style={{ background: "#4f46e5", color: "white", border: "none", borderRadius: "6px", padding: "8px 16px", fontSize: "12px", fontWeight: "700", cursor: "pointer", whiteSpace: "nowrap" }}>
                    Login as Society →
                  </button>
                  <button onClick={() => setDeleteModal(s)}
                    style={{ background: "#dc2626", color: "white", border: "none", borderRadius: "6px", padding: "8px 12px", fontSize: "12px", fontWeight: "700", cursor: "pointer", whiteSpace: "nowrap" }}>
                    🗑 Delete
                  </button>
                </div>
              </div>
            ))}
            {filtered.length === 0 && <div style={{ color: "#a5b4fc", textAlign: "center", padding: "30px" }}>No societies found</div>}
          </div>
        )}
      </div>
    </div>
  );
}
